import ViewTabsDnDV2 from './ViewTabsDnDV2';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ViewTabsDnD() {
  return /*#__PURE__*/_jsx(ViewTabsDnDV2, {
    isMockViewTabsForFolders: false
  });
}